module.exports = __webpack_public_path__ + "static/media/white-space-1500.2f7f67aa.jpg";